import { render, staticRenderFns } from "./StudentProfileHeader.vue?vue&type=template&id=fdc50f90&scoped=true"
import script from "./StudentProfileHeader.vue?vue&type=script&lang=js"
export * from "./StudentProfileHeader.vue?vue&type=script&lang=js"
import style0 from "./StudentProfileHeader.vue?vue&type=style&index=0&id=fdc50f90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc50f90",
  null
  
)

export default component.exports